import { z } from 'zod';

export const ThemeColorListItemSchema = z.object({
  name: z.string(),
  value: z.string(),
  hexValue: z.string()
});

export const ThemeColorListSchema = z.array(ThemeColorListItemSchema);

export type ThemeColorList = z.infer<typeof ThemeColorListSchema>;

export const ColorPickerListItemSchema = z.object({
  name: z.string(),
  value: z.string().optional(),
});

export const ColorPickerListSchema = z.array(ColorPickerListItemSchema);

export type ColorPickerList = z.infer<typeof ColorPickerListSchema>;